<template>
  <div class="box">
    <div class="big_box" v-if="list.length <= 0">
      <div class="big_box_xon">
        <div class="big_box_son" @click="addFrom">
          <img src="../../../assets/img/add_icon.png" alt="" />
          <p>添加作者</p>
        </div>
      </div>
      <div class="fons_red">
        提示：带有
        <img src="../../../assets/img/dianhua2.png" />图标的是通讯作者。
      </div>
    </div>
    <div class="big_box1" v-else>
      <div class="fons_red">
        提示：带有
        <img src="../../../assets/img/dianhua2.png" />图标的是通讯作者。
      </div>
      <div class="list_box">
        <div class="list_item" v-for="(item, i) in list" :key="i">
          <div class="list_item_left">
            <p class="w1">{{ item.name }}</p>
            <p class="w2">{{ item.mobile }}</p>
            <p class="w2">{{ item.company }}</p>
            <p class="w2">{{ item.job }}</p>
            <p></p>
          </div>
          <div class="list_item_right_top" @click="eidtClick(item, i)">
            编辑
          </div>
          <div class="list_item_right">
            {{ item.type == 1 ? '第一作者' : '共同作者' }}
          </div>
        </div>
        <div class="list_item_lats" @click="addFrom" v-if="list.length < 11">
          <img src="../../../assets/img/add_icon.png" alt="" />
          <p>添加作者</p>
        </div>
      </div>
    </div>
    <div class="big_btn">
      <div>
        <button class="trs_btn" @click="nextSpet(0)">上一步</button>
      </div>
      <div>
        <button @click="nextSpet(2)">下一步</button>
      </div>
    </div>
    <el-dialog
      :title="tit"
      :visible.sync="centerDialogVisible"
      width="916px"
      center
    >
      <el-form
        label-position="top"
        :model="form"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm form"
        v-if="centerDialogVisible"
      >
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item prop="name" label="姓名">
              <el-input v-model="form.name" placeholder="姓名">
              </el-input> </el-form-item
          ></el-col>
          <el-col :span="12"
            ><el-form-item prop="company" label="工作单位">
              <el-input v-model="form.company" placeholder="工作单位">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item prop="job" label="职位/职称">
              <el-input v-model="form.job" placeholder="职位/职称">
              </el-input> </el-form-item
          ></el-col>
          <el-col :span="12"
            ><el-form-item prop="email" label="电子邮箱">
              <el-input v-model="form.email" placeholder="电子邮箱"> </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item prop="mobile" label="手机号">
              <el-input v-model="form.mobile" placeholder="手机号">
              </el-input> </el-form-item
          ></el-col>
          <el-col :span="12"
            ><el-form-item prop="address" label="通讯地址">
              <el-input v-model="form.address" placeholder="通讯地址">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12"
            ><el-form-item prop="ems_code" label="邮编">
              <el-input v-model="form.ems_code" placeholder="邮编"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="phone" label="固定号码">
              <el-input v-model="form.phone" placeholder="固定号码">
              </el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item prop="fax" label="传真">
              <el-input v-model="form.fax" placeholder="传真">
              </el-input> </el-form-item
          ></el-col>
          <el-col :span="12">
            <el-form-item prop="is_messager" label="通讯作者">
              <el-select v-model="form.is_messager" placeholder="请选择">
                <el-option
                  v-for="item in options1"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select> </el-form-item
          ></el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12"
            ><el-form-item prop="type" label="联合作者">
              <el-select v-model="form.type" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <div class="login_fot">
          <button @click="centerDialogVisible = false" class="first">
            取 消
          </button>
          <button @click="sbmit" class="sbmit">
            保 存
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      centerDialogVisible: false,
      list: [],
      indexNumber: null,
      ruleForm: {
        emi: ''
      },
      tit: '添加作者',
      form: {
        name: '',
        date2: '',
        delivery: false,
        type: '',
        is_messager: '',
        resource: '',
        desc: '',
        ems_code: ''
      },
      options1: [
        {
          value: "1",
          label: '是'
        },
        {
          value: "0",
          label: '不是'
        }
      ],
      options: [
        {
          value: "1",
          label: '第一作者'
        },
        {
          value: "2",
          label: '共同作者'
        }
      ],
      value: '',
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        company: [
          { required: true, message: '请输入工作单位', trigger: 'blur' }
        ],
        job: [{ required: true, message: '请输入职务', trigger: 'blur' }],
        email: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
        mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入固定号码', trigger: 'blur' }],

        ems_code: [{ required: true, message: '请输入邮编', trigger: 'blur' }],
        fax: [{ required: true, message: '请输入传真', trigger: 'blur' }],

        type: [
          { required: true, message: '请选择联合作者类型', trigger: 'change' }
        ],

        is_messager: [
          { required: true, message: '请选择通讯作者', trigger: 'change' }
        ]
      }
    }
  },
  components: {},
  methods: {
    async eidtClick(val, i) {
      const res = await this.$api.Home.getAuthor(val.author_ids)
      this.tit = '编辑作者'
      this.centerDialogVisible = true
      this.form = res.data
      this.indexNumber = i
    },
    async sbmit() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          if (this.tit == '添加作者') {
            const res = await this.$api.Home.addAuth(this.form)
            let a = {
              name: res.name,
              mobile: res.data.mobile,
              company: res.data.company,
              job: res.data.job,
              type: res.data.type,
              author_ids: res.data.id
            }
            if (res.code == 0) {
              this.list.push(a)
              this.centerDialogVisible = false

              this.$message.success('添加作者成功')
            } else {
              this.$message.error('添加作者失败')
            }
          }
          if (this.tit == '编辑作者') {
            const res = await this.$api.Home.eidtAuthor(this.form)
            let a = {
              name: res.name,
              mobile: res.data.mobile,
              company: res.data.company,
              job: res.data.job,
              type: res.data.type == 1 ? 1 : 2,
              author_ids: res.data.id,
              is_messager: res.data.is_messager == 0 ? 0 : 1
            }
            this.list[this.indexNumber] = a
            if (res.code == 0) {
              this.centerDialogVisible = false
              this.$message.success('编辑作者成功')
            } else {
              this.$message.error('编辑作者失败')
            }
          }
        } else {
          return false
        }
      })

      // console.log(res)
    },
    nextSpet(val) {
      if (val == 2) {
        if (this.list.length == 0) {
          this.$message.warning('请完善作者信息')
        } else {
          this.$emit('data', this.list)

          this.$emit('nextSpet', val)
        }
      } else {
        this.$emit('nextSpet', val)
      }
    },
    addFrom() {
      this.form = {
        xing: '',
        company: '',
        job: '',
        email: '',
        mobile: '',
        address: '',
        phone: '',
        ems_code: '',
        fax: '',
        type: '',
        is_messager: ''
      }
      this.centerDialogVisible = true
      this.tit = '添加作者'
    }
  }
}
</script>
<style lang="less" scoped>
/deep/.el-form-item__label {
  padding: 0 !important;
}
/deep/.el-form-item {
  margin-bottom: 10px !important;
}
/deep/.el-input__inner {
  height: 60px !important;
}
/deep/ .el-form--label-top .el-form-item__label {
  font-size: 20px;
}
.login_fot {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  .first {
    background-color: #ffffff;
  }
  .sbmit {
    color: #ffffff;
  }
  button {
    margin-right: 30px;
    width: 120px;
    height: 60px;
    background-color: #00599e;
    border-radius: 5px;
    border: solid 1px #eeeeee;
    font-family: 'SourceHanSansCN-Regular';
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #666666;
    cursor: pointer;
  }
}
.big_box {
  margin-top: 50px;
  width: 1200px;
  height: 444px;
  background-color: #ffffff;
  padding: 50px;
  box-sizing: border-box;
  .fons_red {
    display: flex;
    height: 18px;
    line-height: 18px;
    font-family: ' SourceHanSansCN-Regular';
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #fe0201;
    img {
      margin: 0 3px;
      width: 18px;
      height: 18px;
    }
  }
  .big_box_xon {
    margin: 0 auto;
    width: 1100px;
    height: 300px;
    background-color: #ffffff;
    border-radius: 5px;
    // border: solid 1px #eeeeee;

    .big_box_son {
      cursor: pointer;
      padding-top: 80px;
      //   margin-top: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      img {
        width: 72px;
        height: 70px;
      }
      p {
        margin-top: 16px;
        font-family: 'SourceHanSansCN-Regular';
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #c9dcea;
      }
    }
  }
}
.box {
  //   width: 1920px;
  //   height: 1572px;
  background-color: #f6fbff;
  .big_btn {
    width: 440px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    .trs_btn {
      width: 200px;
      height: 60px;
      border-radius: 5px;
      background: #fff;
      border: solid 1px #c9dcea;
      font-family: SourceHanSansCN-Regular;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #00599e;
    }
    button {
      width: 200px;
      height: 60px;
      background-color: #00599e;
      border-radius: 5px;
      border: 0;
      font-size: 20px;

      color: #fff;
      margin-top: 40px;
      margin-bottom: 73px;
    }
  }
}
.big_box1 {
  margin-top: 50px;
  width: 1200px;
  // height: 344px;
  background-color: #ffffff;
  padding: 50px;
  box-sizing: border-box;
}
.list_box {
  display: flex;
  // justify-content: space-evenly;
  flex-wrap: wrap;
  margin-top: 22px;
  .list_item_lats {
    width: 300px;
    height: 200px;
    background-color: #ffffff;
    border-radius: 5px;
    border: solid 1px #eeeeee;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    p {
      margin-top: 16px;
      font-family: 'SourceHanSansCN-Regular';
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #c9dcea;
    }
  }
}
.list_item {
  margin-right: 20px;
  margin-bottom: 20px;
  width: 300px;
  height: 200px;
  background-color: #ffffff;
  border-radius: 5px;
  border: solid 1px #eeeeee;
  position: relative;
  .list_item_left {
    margin-top: 40px;
    margin-left: 40px;
    .w1 {
      color: #00599e;
      font-size: 20px;
      margin-bottom: 30px;
    }
    .w2 {
      color: #888888;
      font-size: 18px;
    }
  }
  .list_item_right_top {
    font-size: 13px;
    letter-spacing: 2px;
    position: absolute;
    right: 0;
    top: 0px;
    width: 40px;
    text-align: center;
    height: 28px;
    line-height: 28px;
    background: rgb(26, 169, 212);
    color: #fff;
    cursor: pointer;
  }
  .list_item_right {
    position: absolute;
    right: 0;
    top: 30px;
    width: 130px;
    height: 40px;
    font-size: 16px;
    line-height: 40px;
    background: url('../../../assets/img/dianhua.png');
    text-indent: 50px;
    color: #fff;
  }
}
</style>
